angular.module('leanlaw').controller('ClientCtrl', ['$scope', '$stateParams', 'userService', '$state', 'clientMatterManager', 'alerts', 'tippy', '$timeout', 'matterClientService', function ($scope, $stateParams, userService, $state, clientMatterManager, alerts, tippy, $timeout, matterClientService) {
  // This is a shared state for the client/matter modules
  $scope.module = {
    me: undefined,
    users: undefined,
    client: undefined,
    matter: undefined,
    root: $state.current.name.split('.')[0]
  };

  // TODO move to $scope.vm.*
  $scope.state = $state;
  $scope.tempName = "";
  $scope.loading = true;
  $scope.error = false;
  $scope.summary = {};
  $scope.isEditing = false;
  $scope.reference = '';
  $scope.trustEnabled = false;
  $scope.accounting = null;
  $scope.fakeSummary = false;
  $scope.isMatterMode = false;
  $scope.selectedMatter = undefined;

  // Story 45778 — Toggleable sidebar
  // Read persisted state on controller init (runs before activate, so before first render)
  $scope.sidebarCollapsed = localStorage.getItem('ll_sidebar_collapsed') === 'true';
  $scope.toggleSidebar = () => {
    $scope.sidebarCollapsed = !$scope.sidebarCollapsed;
    localStorage.setItem('ll_sidebar_collapsed', String($scope.sidebarCollapsed));
  };
  activate();
  async function activate() {
    const {
      id
    } = $stateParams;
    if (!id) {
      throw new Error("Client id is missing");
    }
    $scope.loading = true;
    try {
      $scope.module.me = await userService.me();
      const query = {
        scope: 'all',
        matters: 'include',
        contact: 'include'
      };
      $scope.module.client = await clientMatterManager.getClient(id, query);

      //Fill in tempName field for the display name
      if ($scope.module.client.contact.customName) {
        $scope.tempName = $scope.module.client.contact.customName;
      } else {
        //If no custom name (client is not using a custom name) use name field to set the display name field.
        $scope.tempName = $scope.module.client.name;
      }
      $scope.clients = await clientMatterManager.listTabledClients();
      $scope.module.users = await userService.list({
        status: 'registered'
      });
      $timeout(() => {
        tippy('.tippy-avatar');
      });
    } catch (e) {
      console.error(e);
      $scope.error = true;
    } finally {
      $scope.loading = false;
    }
  }
  $scope.goBack = () => {
    $state.go("^");
  };
  $scope.selectClient = async ({
    id
  }) => {
    const parentClientState = `${$scope.module.root}.client.view`;
    const currentTab = getCurrentTab(`${parentClientState}`);
    const tab = currentTab === 'info' || currentTab === 'overview' || currentTab === 'billingActivity' ? currentTab : 'overview';
    $state.go(`${parentClientState}.${tab}`, {
      id
    });
    $scope.module.matter = undefined;
  };
  function getCurrentTab() {
    const pieces = $state.current.name.split('.');
    return pieces[pieces.length - 1];
  }
  $scope.$on('matterBillingIsDirty', (event, data) => {
    $scope.matterBillingIsDirty = data;
  });
  $scope.selectMatter = async matter => {
    if ($scope.matterBillingIsDirty) {
      alerts.warning("You have unsaved changes. Save or undo changes first.");
      return;
    }
    // Note that when selecting a matter we will try to stay on the same tab. Gets a little fiddly
    // when the we deselect a matter or select a matter when we don't have any selected already

    const parentMatterState = `${$scope.module.root}.client.matter`;
    const currentTab = getCurrentTab();
    if ($scope.module.matter && $scope.module.matter.id === matter.id) {
      // unselect if this matter is currently selected
      const tab = currentTab === 'overview' || currentTab === 'info' || currentTab === 'billingActivity' ? currentTab : 'overview';
      $scope.module.matter = undefined;
      $state.go(`${$scope.module.root}.client.view.${tab}`, {
        id: $stateParams.id
      });
      return;
    }
    let tab = $scope.module.matter || currentTab === 'info' || currentTab === 'overview' || currentTab === 'billingActivity' ? currentTab : 'info';
    // Settlement, Liens, and Fee Recipients tabs are only available for contingency matters — redirect to info if switching to a non-contingency matter
    if ((tab === 'settlement' || tab === 'liens' || tab === 'feeRecipients') && matter.billing?.type !== 'contingency') {
      tab = 'info';
    }
    $scope.module.matter = matter;
    $state.go(`${parentMatterState}.${tab}`, {
      id: $stateParams.id,
      matterId: matter.id
    });
  };
  $scope.initials = person => matterClientService.initials(person);
  $scope.$on("$locationChangeStart", () => {
    // help: @fred I need a way to to clear the selected matter when navigating back from matter to client
    // $scope.module.matter = undefined;
  });
}]);